export default function sortJudgesByName (names) {
	const getLastName = person => person.full_name.split(' ').pop().toUpperCase()

	const sortAlphabeticallyByLastName = (a, b) => {
		return getLastName(a) > getLastName(b) ? 1 : -1
	}

	return names.sort(sortAlphabeticallyByLastName)
}



// WEBPACK FOOTER //
// ./src/assets/js/sortJudgesByName.js